module.exports = __webpack_public_path__ + "static/media/bus2.0b8fec29.jpg";